import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@/lib/query-client';
import { router } from '@/routes/router';

/**
 * Raíz de la aplicación: el cache de TanStack Query arriba de todo, y el router debajo.
 *
 * El registro del handler de 401 vive en `main.tsx` (`registerSessionGuard`), antes del
 * primer render, para que ninguna query pueda dispararse sin protección.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
